import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/globals';

import 'object-fit-videos';
import 'vanilla-lazyload';
import '@eneserk/lazyembed';
import 'jquery';
import 'popper.js';
import 'fancybox/dist/js/jquery.fancybox';

/**
 * Bootstrap
 */
import 'bootstrap/js/src/util';
//import 'bootstrap/js/src/alert';
//import 'bootstrap/js/src/button';
//import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/scrollspy';
import 'bootstrap/js/src/tab';
//import 'bootstrap/js/src/tooltip';
//import 'bootstrap/js/src/popover';

/**
 * Bootstrap Select
 */
import 'bootstrap-select';

/**
 * Slick
 */
import 'slick-carousel';

/**
 * Light Galery
 */
import 'lightgallery';
//import 'lg-autoplay';
//import 'lg-fullscreen';
//import 'lg-hash';
//import 'lg-pager';
//import 'lg-share';
//import 'lg-thumbnail';
//import 'lg-video';
//import 'lg-zoom';

/**
 * Project
 */
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/viewport';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/sizeChange';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/objectFitVideos';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/lightGallery';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/lazyload';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/lazyEmbed';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/menu';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/selectInput';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/form';
import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/search';
import '../../../../Avency.DMI.Base/Resources/Private/Fusion/Component/Molecule/CollapseContent/CollapseContent';

import '../../../../Avency.DMI.Base/Resources/Private/Assets/JavaScript/Project/slick';
import '../../../NodeTypes/Content/Basics/LogoSlider/LogoSlider'


// ImageTextTeaserSlider
import '../../../../Avency.DMI.Site/Resources/Private/Fusion/Component/Molecule/ImageTextTeaserSlider/ImageTextTeaserSlider';


/**
 * HealthComm
 */
import './JavaScripts/Project/menu';

import '../../../../Avency.DMI.Files/Resources/Private/Fusion/Component/Molecule/FileListing/FileListing';